import React, { useState, useEffect } from "react";
import axios from "axios";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Post from "./Post";
import Loader from "./Loader";
import "./Posts.css";
import ThumbsUp from "./ThumbsUp";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronCircleDown } from "@fortawesome/free-solid-svg-icons";

const Posts = props => {
  const perPage = 10;
  const [posts, setPosts] = useState([]);
  const [isLoaded, setIsLoaded] = useState(false);
  const [page, setPage] = useState(1);
  const [moreLoading, setMoreLoading] = useState(false);
  const [allPostsLoaded, setAllPostsLoaded] = useState(false);

  const getPosts = () => {
    const getUrl = `http://admin.kapoff.se/wp-json/wp/v2/posts?_embed&per_page=${perPage}&page=${page}`;
    axios
      .get(getUrl)
      .then(res => {
        setPosts([...posts, ...res.data]);
        setIsLoaded(true);

        setMoreLoading(false);
        setAllPostsLoaded(res.headers["x-wp-totalpages"] <= page);
      })
      .catch(err => console.log(err));
  };

  const loadMore = () => {
    setPage(page + 1);
    setMoreLoading(true);
  };

  useEffect(() => {
    getPosts();
  }, [page]);

  if (isLoaded) {
    return (
      <Row className="portfolio">
        {posts.map(post => (
          <Post
            key={post.id}
            title={post.title.rendered}
            media={post.featured_media}
            meta={post.acf}
            term={post._embedded["wp:term"][0]}
          />
        ))}
        <Col xs="12" className="mt-4 mb-4 text-center">
          {allPostsLoaded ? (
            <ThumbsUp />
          ) : moreLoading ? (
            <Loader />
          ) : (
            <FontAwesomeIcon
              className="moreButton"
              icon={faChevronCircleDown}
              onClick={loadMore}
            />
          )}
        </Col>
      </Row>
    );
  }
  return (
    <Row>
      <Col xs="12" className="text-center mt-4">
        <Loader />
      </Col>
    </Row>
  );
};

export default Posts;



// WEBPACK FOOTER //
// ./src/components/Posts.jsx